import { Injectable, inject } from '@angular/core';
import {
  SettingsFacade,
  UserFacade,
} from '@lyceo/lyceo-pupil-app/user/data-access';
import { filter, Observable, switchMap } from 'rxjs';
import { combineLatest } from 'rxjs';
import { Permission } from '@lyceo/lyceo-pupil-app/shared/util-models';
import { map } from 'rxjs/operators';
import { PermissionService } from '@lyceo/shared/permissions/data-access';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class LevelYearSetService {
  private readonly settingsFacade: SettingsFacade = inject(SettingsFacade);
  private readonly userFacade: UserFacade = inject(UserFacade);
  private readonly permissionService: PermissionService =
    inject(PermissionService);

  public levelYearSetCheck(): Observable<boolean> {
    return toObservable(this.userFacade.practisePermissionsLoaded).pipe(
      filter((loaded) => loaded),
      switchMap(() =>
        combineLatest([
          this.permissionService.hasPermission([
            Permission.PRACTICE_MODULE_EXAM,
            Permission.PRACTICE_MODULE_METHOD,
          ]),
          this.permissionService.hasPermission(
            Permission.PRACTICE_MODULE_ACADEMY,
          ),
        ]),
      ),
      map(
        ([hasPractiseExamOrMethod, hasPractiseAcademy]) =>
          !!(
            !hasPractiseExamOrMethod ||
            hasPractiseAcademy ||
            this.settingsFacade.practiceLevelYearSet()
          ),
      ),
    );
  }
}
